module.exports = __webpack_public_path__ + "img/introduce2.6305bae0.png";